import Alpine from 'alpinejs';
import { collapse } from '@alpinejs/collapse';
import { resize } from '@alpinejs/resize';

// Alpine Components
import './alpine/HeroCarousel';
import './alpine/DownloadModal';
import './alpine/TabbedContent';
import './alpine/StepCarousel';
import './alpine/KeyDatesSwiper';
import './alpine/Marquee';
import './alpine/AnnouncementBanner';
import './alpine/UI';
import './alpine/GlossaryReference';

//Components
import './components/pageFeedback';

// Global
window.Alpine = Alpine;

// Plugins
Alpine.plugin(collapse); 
Alpine.plugin(resize);

// Inits
Alpine.start();